module.exports = "/_next/static/images/Twitter-3befa7f8c655de536c946f85785d2485.svg";